<template>
  <card class="flat mx-3 my-5" body-classes="p-0" footer-classes="pb-2">
    <div class="d-flex align-items-center justify-content-between m-2">
      <div class="d-flex align-items-center">
        <span class="mx-2">Translation Usage Month </span>
        <vue-monthly-picker v-model="month" :clear-option="false">
        </vue-monthly-picker>
        <base-button
          class="mx-4"
          type="success"
          size="sm"
          @click="downloadExcel"
          :disabled="usage.total_usage <= 0"
        >
          Export Excel
        </base-button>
      </div>
      <b-btn-close @click="() => $router.go(-1)">
        <b-icon-x></b-icon-x>
      </b-btn-close>
    </div>
    <el-tabs v-model="activeTab" class="mx-3">
      <el-tab-pane label="Document" name="document">
        <file-usage-table :files="files" :loading="loading"> </file-usage-table>
      </el-tab-pane>
      <el-tab-pane label="Sentence" name="sentence">
        <sentence-usage-table
          :sentences="sentences"
          :loading="loading"
        ></sentence-usage-table>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="col-12 d-flex justify-content-center flex-wrap">
      <div>{{ summary }}</div>
    </div>
  </card>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'
import FileUsageTable from '@/views/FileUsageTable'
import SentenceUsageTable from '@/views/SentenceUsageTable'
export default {
  name: 'UsagePage',
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    VueMonthlyPicker,
    FileUsageTable,
    SentenceUsageTable,
  },
  data() {
    return {
      month: moment().utc(),
      activeTab: 'document',
      usage: {
        total_usage: 0,
        total_file: 0,
        total_str: 0,
        detail: [],
      },
      loading: false,
    }
  },
  computed: {
    files() {
      return this.usage.detail[0]?.files
    },
    start() {
      const date = this.month.toDate()
      return new Date(date.getFullYear(), date.getMonth(), 1)
    },
    end() {
      const year = this.start.getFullYear()
      const month = this.start.getMonth()
      return new Date(year, month + 1, 1)
    },
    summary() {
      const when = `${this.start.getFullYear()}.${this.start.getMonth() + 1}`
      const total = `Total translation usage: ${this.usage.total_usage}`
      const document = `document: ${this.usage.total_file}`
      const sentence = `sentence: ${this.usage.total_str}`
      return `${when} ${total} (${document}, ${sentence})`
    },
    sentences() {
      return this.usage.detail.flatMap(e => e.str_detail)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      const uid = this.$store.state.uid
      if (!uid) this.$router.go(-1)
      try {
        this.loading = true
        await this.fetchUsage()
      } finally {
        this.loading = false
      }
    },
    async fetchUsage() {
      const startTimestamp = this.start.getTime()
      const endTimestamep = this.end.getTime()
      const { data } = await this.$slowbro.get('/me/usage', {
        params: {
          from: new Date(startTimestamp).toISOString(),
          to: new Date(endTimestamep).toISOString(),
        },
      })
      this.usage = data
    },
    async downloadExcel() {
      const startTimestamp = this.start.getTime()
      const endTimestamep = this.end.getTime()
      const params = {
        from: new Date(startTimestamp).toISOString(),
        to: new Date(endTimestamep).toISOString(),
      }
      const response = await this.$slowbro.get('/me/usage/excel', {
        params,
        responseType: 'blob',
      })
      await this.$sync.downlaodBlobResponse(response)
    },
  },
  watch: {
    start() {
      this.setup()
    },
  },
}
</script>
<style scoped lang="scss">
.toast-message {
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 999;
}
.header {
  white-space: pre-line;
  text-align: center;
}
</style>
